import { Button } from '@dev-spendesk/grapes';

import { useTranslation } from 'src/core/common/hooks/useTranslation';
import { formatMonetaryValue } from 'src/core/utils/monetaryValue';

import { type MoneyAmount } from '../../types';

type Props = {
  totalPrice: MoneyAmount | null;
  nights: number;
  travelers: number;
  onAddStayToTrip: () => void;
  isDisabled?: boolean;
};

export const BookingFooter = ({
  totalPrice,
  nights,
  travelers,
  onAddStayToTrip,
  isDisabled = false,
}: Props) => {
  const { t } = useTranslation('global');

  return (
    <div className="rounded-12 elevation-xl sticky bottom-0 z-50 flex items-center justify-between gap-16 bg-[rgba(255,255,255,0.9)] p-16 backdrop-blur-[5px]">
      <div className="flex flex-col gap-4">
        <p className="title-xl">
          {totalPrice ? formatMonetaryValue(totalPrice) : '—'}
        </p>
        <p className="body-m text-content-secondary-bg-primary">
          {t('travel.propertyDetails.bookingFooter.nightsTravelers', {
            nights,
            travelers,
          })}
        </p>
      </div>
      <div className="flex flex-col items-end gap-8">
        <Button
          variant="primaryBrand"
          text={t('travel.propertyDetails.bookingFooter.addStayToTrip')}
          onClick={onAddStayToTrip}
          isDisabled={isDisabled || !totalPrice}
        />
        <p className="body-s text-content-secondary-bg-primary text-right">
          {t('travel.propertyDetails.bookingFooter.notChargedYet')}
        </p>
      </div>
    </div>
  );
};
